'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import AdvancedFiltersPanel from './AdvancedFiltersPanel';
import SearchResults from './SearchResults';

export default function AdvancedSearchLayout() {
  const [resultsCount, setResultsCount] = useState(8);

  return (
    <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-8">
      {/* Page Header */}
      <div className="mb-8">
        <div className="flex items-center gap-2 text-muted-foreground text-sm mb-3">
          <Icon name="HomeIcon" size={14} />
          <span>/</span>
          <span className="text-foreground font-medium">Advanced Search</span></div>
        <h1 className="text-3xl font-extrabold text-foreground mb-2">Advanced Property Search</h1>
        <p className="text-muted-foreground text-base">Use comprehensive filters to find your perfect property across the GCC</p>
      </div>

      <div className="flex gap-8">
        {/* Filters Panel */}
        <div className="w-80 flex-shrink-0 hidden lg:block">
          <AdvancedFiltersPanel onResultsChange={setResultsCount} />
        </div>

        {/* Results */}
        <div className="flex-1 min-w-0">
          <SearchResults count={resultsCount} />
        </div>
      </div>
    </div>
  );
}